// Bouton "Connecter mon compte Instagram" — démarre le flow OAuth Meta.
//
// Le user doit être déjà authentifié à Falko (le backend vérifie via JWT).
// ⚠️ Comme c'est une navigation HTML (<a href>), le navigateur n'envoie pas
// automatiquement le header Authorization. Solution pragmatique MVP : on passe
// le JWT en query string ?token=... que le backend accepte aussi (en plus du header).

import { useAuthStore } from '../../store/authStore';

interface ConnectInstagramButtonProps {
  label?: string;
  className?: string;
}

export const ConnectInstagramButton = ({
  label = 'Connecter mon compte Instagram',
  className = '',
}: ConnectInstagramButtonProps) => {
  const accessToken = useAuthStore((s) => s.tokens?.accessToken);
  // Si pas de token (utilisateur déconnecté), on renvoie vers /login plutôt que /api/auth/meta
  const href = accessToken
    ? `/api/auth/meta?token=${encodeURIComponent(accessToken)}`
    : '/login';

  return (
    <a
      href={href}
      className={`inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 px-5 py-2.5 text-sm font-semibold text-white shadow hover:opacity-95 transition ${className}`}
    >
      <InstagramLogo />
      {label}
    </a>
  );
};

const InstagramLogo = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
  </svg>
);
